import { mapCourse, stripHtmlText } from './dashboardMappers';

const PLACEHOLDER_AVATAR =
  'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=500&fit=crop&crop=face';

function mapCertification(cert, index) {
  if (typeof cert === 'string') {
    return { id: index + 1, label: cert.trim() };
  }

  return {
    id: cert.id ?? index + 1,
    label: (cert.label || cert.name || cert.title || '').trim(),
  };
}

function mapAchievement(item) {
  if (typeof item === 'string') return item.trim();
  return (item?.title || item?.description || item?.label || '').trim();
}

function darkenHex(hex, amount = 28) {
  const raw = String(hex || '').replace('#', '').trim();
  if (!/^[0-9a-fA-F]{6}$/.test(raw)) return hex;

  const channels = [0, 2, 4].map((offset) => {
    const value = parseInt(raw.slice(offset, offset + 2), 16);
    return Math.max(0, Math.min(255, value - amount))
      .toString(16)
      .padStart(2, '0');
  });

  return `#${channels.join('')}`;
}

function resolveSubjectColorCode(data) {
  const direct = data?.subject_color_code?.trim();
  if (direct) return direct;

  const fromCourse = (data?.courses || []).find((course) => course?.subject_color_code)?.subject_color_code;
  return fromCourse?.trim() || null;
}

export function mapInstructorDetail(data, { subjectColorCode: fallbackColor } = {}) {
  if (!data) return null;

  const qualification = data.qualification?.trim();
  const experienceYears = data.experience_years ?? data.experience;
  const videoCount = data.number_of_videos ?? data.videos_count;

  const stats = [
    qualification ? { id: 'degree', label: qualification } : null,
    experienceYears != null && experienceYears !== ''
      ? { id: 'experience', label: `${experienceYears} yrs Experience` }
      : null,
    videoCount != null && videoCount !== ''
      ? { id: 'videos', label: `${videoCount} Videos` }
      : null,
  ].filter(Boolean);

  const certifications = (data.certifications || [])
    .map(mapCertification)
    .filter((cert) => cert.label);

  const achievements = (data.achievements || []).map(mapAchievement).filter(Boolean);

  const courses = (data.courses || []).map(mapCourse).filter(Boolean);

  const about = stripHtmlText(data.about || '');
  const biodescription = stripHtmlText(data.bio_description || '');
  const coverPhoto = data.cover_photo_url?.trim() || null;

  const certificationStory =
    coverPhoto || about
      ? {
          image: coverPhoto,
          imageCaption: (data.title || data.name || '').trim(),
          text: about,
        }
      : null;

  const title = (data.title || '').trim() || 'Expert';
  const subjectColorCode = resolveSubjectColorCode(data) || fallbackColor?.trim() || null;
  const gradientStyle = subjectColorCode
    ? {
        backgroundImage: `linear-gradient(90deg, ${subjectColorCode}, ${darkenHex(subjectColorCode)})`,
      }
    : {
        backgroundImage: 'linear-gradient(90deg, #9369CC, #6A74E1)',
      };

  return {
    id: data.id,
    name: data.name || 'Instructor',
    title,
    biodesc:biodescription,
    bio: about,
    profileImage: data.profile_image_url?.trim() || PLACEHOLDER_AVATAR,
    subjectColorCode,
    gradientStyle,
    stats,
    certifications,
    certificationStory,
    achievements,
    courses,
  };
}
